<template>
    <div
        class="modal fade"
        id="talenttest-help"
        tabindex="-1"
        role="dialog"
        aria-labelledby="talenttest-help"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="lunchmodalLabel">
                        Hjælp til testen
                    </h2>
                    <button
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">
                            &times;
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <h2 class="modal-title">
                        Sådan skal du svare
                    </h2>
                    <p>
                        For bedst muligt at kunne udregne dine talenter, er det vigtigt, at du svarer ærligt på testen. Du skal svare efter egen overbevisning, og ikke som du kunne tænke dig at være. Forestil dig hvordan en god kollega ville svare på dine vegne, hvis du er i tvivl.
                    </p>

                    <h2 class="modal-title">
                        Spring over
                    </h2>
                    <p>
                        "Spring over"-knappen skal kun bruges, når du virkelig ikke ved, hvordan du skal svare. Hvis du klikker på den for mange gange, kan vi ikke være lige så sikre på de resultater, vi viser til dig. Det er derfor vigtigt, at du så vidt muligt forsøger at vælge en af de to svarmuligheder.
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Luk
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TestHelp",
};
</script>
